import { render, staticRenderFns } from "./AlertTable.vue?vue&type=template&id=3bc1b5fe&"
import script from "./AlertTable.vue?vue&type=script&lang=js&"
export * from "./AlertTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports